"use client";
import { Content } from "@radix-ui/react-tabs";
import clsx from "clsx";

import { Button, ButtonLink, Heading } from "@/components/atoms";
import Preamble from "@/components/atoms/Preamble/Preamble";
import { useCart } from "@/lib/hooks/useSelection";

import CartItems from "../CartItems/CartItems";
import CartSummary from "../CartSummary/CartSummary";
import styles from "./cart.module.css";
import { CartUpsell } from "./CartUpsell";
import { useCartPreOrder } from "./hooks/useCartPreorder";

const CartContent = ({ setTab }: { setTab: any }) => {
  const { items, modal, cart } = useCart();
  const { orderType } = useCartPreOrder();

  const showPreOrderInfo = orderType !== "standard";

  if (cart.summary?.totalQuantity === 0) {
    return (
      <Content className={clsx(styles["cart-content"])} value="cart">
        <div className={styles["cart-empty"]}>
          <Preamble>Shopping Cart</Preamble>
          <Heading as="h3" styledAs="h4">
            Your cart is empty
          </Heading>
          <div className={styles.buttons}>
            <Button onClick={() => setTab("wishlist")} outlined>
              Go to wishlist
            </Button>
            <ButtonLink
              href="/products"
              color="black"
              textColor="white"
              onClick={modal.toggleModal}
            >
              Go shopping
            </ButtonLink>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content className={clsx(styles["cart-content"])} value="cart">
      <div className={styles.container}>
        {showPreOrderInfo && (
          <>
            <div className={styles.preorderInfo}>
              <div className={styles.preorderNotice}>
                This order contains pre-order items. Please note that if you add
                other products to your cart, the entire order will be shipped
                together once the pre-order items are available.
              </div>
            </div>
          </>
        )}
        <CartItems items={items} />
        <CartUpsell />
      </div>

      {(cart.summary?.totalQuantity || 0) > 0 && (
        <CartSummary summary={cart.summary} modal={modal} />
      )}
    </Content>
  );
};

export default CartContent;

export const EstShippingDate = ({ preOrderDate }: { preOrderDate: string }) => {
  if (!preOrderDate) return null;

  const [day, month, year] = preOrderDate.split(".");
  const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

  if (isNaN(date.getTime())) return null;

  const formattedDate = date
    .toLocaleDateString("nb-NO", {
      day: "2-digit",
      month: "long",
    })
    .replace(",", "");

  return (
    <div className={styles.estShipping}>
      <p>Estimated shipping date: {formattedDate}</p>
    </div>
  );
};
